// © Microsoft Corporation. All rights reserved.
export default function getAgoText(dateTimeStr) {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    let shortMonthStr;

    const date = new Date(dateTimeStr);
    const nowTs = new Date().getTime();
    const seconds =  Math.floor((nowTs-date.getTime())/1000);

    if (seconds < 30) {
        return "Just now";
    }

    try {
        shortMonthStr = date.toLocaleString("default", { month: "short" });
    } catch (e) {
        shortMonthStr = monthNames[date.getMonth()-1];
    }

    if (seconds > 604800*52) { // 1 year
        return `${shortMonthStr} ${date.getDate()}, ${date.getFullYear()}`;
    }
    if (seconds > 604800) { // 1 week
        return `${shortMonthStr} ${date.getDate()}`;
    }
    if (seconds > 86400) { // 1 day
        return `${Math.floor(seconds/(86400))}d`;
    }
    if (seconds > 3600) { // 1 hour
        return `${Math.floor(seconds/3600)}h`;
    }
    if (seconds >= 60) { // 1 min
        return `${Math.floor(seconds/60)}m`;
    }

    return `${seconds}s`;
}